var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgHashtag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1429 18.4912H41.9438L40.9911 24.2055H47.1429C48.7205 24.2055 50 22.9269 50 21.4287C50 19.8484 48.7232 18.4912 47.1429 18.4912ZM10 38.5716C10 40.1492 11.2795 41.3484 12.8571 41.3484H18.0563L19.0089 35.6341H12.8571C11.2795 35.6341 10 36.9912 10 38.5716ZM44.2857 35.6341H24.8036L23.8509 41.3484H44.2857C45.8634 41.3484 47.1429 40.0689 47.1429 38.5716C47.1429 36.9912 45.8661 35.6341 44.2857 35.6341ZM15.7143 24.2055H35.1964L36.1491 18.4912H15.7143C14.1366 18.4912 12.8571 19.7707 12.8571 21.3484C12.8571 23.0091 14.1366 24.2055 15.7143 24.2055Z",
    fill: "url(#paint0_linear_441_30702)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40.473 10.0386C38.9078 9.78191 37.4444 10.8324 37.1846 12.3868L33.2971 35.7172H39.0899L42.8212 13.3332C43.0801 11.7707 42.0265 10.2984 40.473 10.0386ZM31.464 46.6699C31.2046 48.227 32.2565 49.6984 33.8123 49.9582C33.973 49.9913 34.1337 50.0002 34.2855 50.0002C35.6569 50.0002 36.8676 49.01 37.1007 47.6136L38.131 41.4288H32.3382L31.464 46.6699ZM17.1819 46.6699C16.9224 48.227 17.9743 49.6984 19.5301 49.9582C19.6873 49.9913 19.848 50.0002 19.9998 50.0002C21.3712 50.0002 22.5819 49.01 22.8149 47.6136L26.7051 24.2056H20.9105L17.1819 46.6699ZM26.1873 10.0386C24.6221 9.78191 23.1587 10.8324 22.8989 12.3868L21.8658 18.4913H27.6605L28.5345 13.2466C28.7944 11.7707 27.7408 10.2984 26.1873 10.0386Z",
    fill: "url(#paint1_linear_441_30702)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_441_30702",
    x1: 30,
    y1: 18.4912,
    x2: 30,
    y2: 41.3484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_441_30702",
    x1: 30.0014,
    y1: 10,
    x2: 30.0014,
    y2: 50.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgHashtag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hashtag.d9d19595119f3dd3654858883057243e.svg";